import FootballState from "../../../../state/football-state";
import FootballStatsCategory from "../../../../stats/football-stats-category";
import StatsRule from "../../../../../common/stats-rule";

export default class PuntBlockedStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.PuntBlocked &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { puntedBy: player, id } =
            play.getPreceedingFragment(fragment, [
                FootballState.Punt,
                FootballState.CflKick
            ]) || {};

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            driveId: gameContext.currentDriveId,
            fragmentId: id,
            category: FootballStatsCategory.PUNT_BLOCKED,
            values: {
                completed: 1
            }
        });
    }
}
